import {Loader, Segment} from 'semantic-ui-react';
import PropTypes from 'prop-types';

export default function Spinner({dimensions, hide}) {
  const display = hide ? 'none' : 'contents';
  const width = dimensions?.width;
  const height = dimensions?.height;
  return (
    <Segment
        basic
        padded="very"
        className="spinner"
        style={{display, height, width}}
        data-testid="spinner"
    >
      <Loader size="huge" active/>
    </Segment>
  );
}
Spinner.propTypes = {
  dimensions: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number,
  }),
  hide: PropTypes.bool,
};
Spinner.defaultProps = {
  dimensions: {},
  hide: false,
};
